export default __webpack_public_path__ + "static/media/done-stamp.d2f48906.gif";